import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IResult } from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import ItineraryAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/itinerary-route/itinerary.entity";
import { ICreateSubRouteItinerary } from "../../sub-routes/sub-route-itinerary/interfaces/create-route-itinerary.interface";
import { IUpdateRoute } from "../interfaces/update-route.interface";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "route_group_itinerary";

@Injectable({
  providedIn: "root",
})
export class RouteItineraryService extends AbstractService<
  ItineraryAttributes,
  ICreateSubRouteItinerary,
  IUpdateRoute
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByRouteId(routeId: string): Observable<IResult<ItineraryAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${routeId}`;
    return this.http.get<IResult<ItineraryAttributes>>(API_URL);
  }
}
